import './App.css';
import Quiz from './component/Quiz'

function App() {
  return (
    <div>
      <Quiz/>
    </div>
  );
}

export default App;
